import { h } from 'preact';

const Location = (props) => {
	return (
		<svg viewBox="0 0 16 16" role='img' {...props}>
			<path class="st0" d="M3.248,6.611L7.69,8.31l1.7,4.443l4.09-10.232L3.248,6.611z M6.915,9.084L1.354,6.958
				c-0.47-0.18-0.472-0.477-0.004-0.664l13.077-5.228c0.467-0.187,0.696,0.041,0.509,0.509L9.707,14.651
				c-0.187,0.467-0.485,0.466-0.664-0.004L6.915,9.084z"/>
		</svg>
	);
};

export default Location;
